export default {
      id: "vipps-smiley-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#vipps-smiley-icon",
      toString: function () {
        return this.url;
      }
    }